export default ({ app: { context: { route } }, redirect }) => {
  const forcedLowercaseSlug = route.path.toLowerCase();
  if (forcedLowercaseSlug !== route.path) {
    redirect(forcedLowercaseSlug, route.query);
  }
};
